import { Breakpoints } from 'common/enums';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { PlusIcon } from 'assets/icons';
import { useMediaQuery } from 'hooks/use-media-query';
import { classnames } from 'helpers/utils';
import { TemplateStateType } from 'pages/templates/templates-reducer';
import { templatesCountMaxLength } from 'config/constants';
import CypressIds from 'cypressIds';
import styles from './templates-header.module.scss';

type TemplatesHeaderProps = {
  templatesState: TemplateStateType;
  className?: string;
  notifyAddTemplate: () => void;
};

const TemplatesHeader: React.FC<TemplatesHeaderProps> = ({
  className = '',
  templatesState,
  notifyAddTemplate,
}) => {
  const mobile = useMediaQuery(`(max-width: ${Breakpoints.lg}px)`);

  return (
    <div className={className}>
      <div className={styles.templatesTitleAndDescription}>
        <div className={classnames('text__title1__gray800', styles.title)}>
          Templates
        </div>
        <div className={classnames('text__body__regular__small__gray700')}>
          Templates are reusable lists of Topics for planning interviews.
        </div>
      </div>
      <Button
        buttonSize={mobile ? ButtonSize.Tiny : ButtonSize.Small}
        onClick={notifyAddTemplate}
        disabled={
          templatesState.templatesList.length >= templatesCountMaxLength
        }
        dataCy={CypressIds.templatesAddButton}
        buttonStyle={ButtonStyle.SecondaryGray}
        className={styles.buttonContainer}
      >
        <div className={styles.addButton}>
          <span className="text__body__semi__bold__small__brand700">
            {' '}
            New Template
          </span>
          <PlusIcon />
        </div>
      </Button>
    </div>
  );
};

export { TemplatesHeader };
